import { ApiCore } from "../utilities/ApiCore";
import dbConnection from "../utilities/dbConnection";
import { handleDownload, handleError, handleResponse } from "../utilities/Response";


const url = 'asistentes';
const plural = 'asistentes';
const single = 'asistente';

const apiAsistentes = new ApiCore({
    getSingle: true,
    getAll: true,
    post: true,
    put: true,
    delete: true,
    url: url,
    plural: plural,
    single: single,
    extra: true,
})

apiAsistentes.deleteMany = (id_evento) => {
    return dbConnection.delete(`/${ url }/evento/${ id_evento }`)
        .then( handleResponse )
        .catch( handleError )
}

apiAsistentes.getConstancia = (id_asistente) => {
    return dbConnection.get(`/asistentes/pdf/${id_asistente}`, {
        headers: {
            'Content-Type': 'application/pdf'
        }
    })
        .then( handleDownload )
        .catch(handleError)
}

apiAsistentes.getResumen = () => {
    return dbConnection.get(`/asistentes/resumen`)
        .then( handleResponse )
        .catch( handleError )
}

export default apiAsistentes;